import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Report.scss";
import { Reportmenupos } from "./Reportmenupos";
import { toFormatPrice } from "../common/helpers/function";
import { Daterangepos } from "../common/Daterangepos";
import SocialModal from "../../components/common/modules/SocialModal/SocialModal";
import TableModal from "../common/Modals/tableColumnPos";
import { _Api } from "../common/api/_call";
import DailySaleReportTableHead from "./DailySaleReportTableHead";
import { useReportColumnFilters } from "./useReportColumnFilters";
import {
  getNextSortConfig,
  sortSalePersonReportRows,
} from "./salePersonReportTableConfig";
import { useReportStickyColumns } from "./useReportStickyColumns";
import { possalepersonreport_head } from "../../components/common/Tablehead";
import { loading, Updateloading } from "../common/helpers/toastify";
import { useTranslation } from "react-i18next";
import { Pagination } from "../common/Pagination";
import Select from "react-select";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
const Salepersonreport = () => {
    const { t } = useTranslation();
    const [newcolumndata, setnewcolumndata] = useState(possalepersonreport_head);
    const [socialurl, setSocialurl] = useState();
    const [filtername, setFiltername] = useState("");
    const [datefilter, setDatefilter] = useState([]);
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const [salepersondata, setSalepersondata] = useState([])
    const [lowercount, setLowercount] = useState()
    const [shareloader, setShareloader] = useState(false);
    const [limit, setLimit] = useState(100);
    const [uppercount, setUpercount] = useState();
    const [sortConfig, setSortConfig] = useState({
        columnIndex: 1,
        direction: "desc",
    });
    const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

    const activeTableColumns = newcolumndata?.length
        ? newcolumndata
        : possalepersonreport_head;

    const columnFilters = useReportColumnFilters(salepersondata, { customer: "customer", "sales person": "sales_person" })
    const sortedSalepersondata = useMemo(
        () => sortSalePersonReportRows(columnFilters.rows, sortConfig),
        [columnFilters.rows, sortConfig]
    );

    const handleSalePersonSort = (columnIndex, direction) => {
        setSortConfig((current) => getNextSortConfig(current, columnIndex, direction));
    };

    const reportTableContainerRef = useRef(null);
    useReportStickyColumns(reportTableContainerRef, [
        sortedSalepersondata,
        activeTableColumns,
    ]);
    const getshareresalepersonreport = async () => {
        setShareloader(true);
        try {
            const postdata = {
                "search": filtername,
                "start_date": datefilter ? datefilter[0] : "",
                "end_date": datefilter ? datefilter[1] : ""
            };
            let res = await _Api(postdata, `api/v1/POS/reports/print/salesPerson`);

            if (res.code === 200) {
                setSocialurl(res?.link);
                setShareloader(false);
            }
        }
        catch (err) {
            console.log(err, 'err');
        }

    }
    const getprintsaleparsonrreport = async () => {
        let GetloadingID = loading();
        try {
            const postdata = {
                "search": filtername,
                "start_date": datefilter ? datefilter[0] : "",
                "end_date": datefilter ? datefilter[1] : ""
            };
            let res = await _Api(postdata, `api/v1/POS/reports/print/salesPerson`);

            if (res.code === 200) {
                setTimeout(() => {
                    const exportLinkElement = document.createElement('a');
                    exportLinkElement.hidden = true;
                    exportLinkElement.download = res?.name ? res?.name : "report.pdf";
                    exportLinkElement.href = res?.link;
                    exportLinkElement.text = "downloading...";
                    exportLinkElement.setAttribute('target', '_blank');
                    document.body.appendChild(exportLinkElement);
                    exportLinkElement.click();
                    exportLinkElement.remove();
                    Updateloading(t, GetloadingID, t("download successfully"));

                }, 50)
                setSocialurl(res?.link);
            } else {
                Updateloading(t, GetloadingID, res?.message ? (res?.message) : (res?.errors), 'error');
            }
        }
        catch (err) {
            console.log(err, 'err');
            Updateloading(t, GetloadingID, err, t('error'));
        }

    }
    const callcolumns = async () => {
        try {
            const postdata = {
                name: "report_salepersonreport_tbl",
            };
            let columnhead = await _Api(
                postdata,
                `api/v1/Inventory/common/getColumnHeads`
            );
            if (columnhead.code === 200) {
                setnewcolumndata(columnhead?.data?.data);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };
    useEffect(() => {
        callcolumns();
    }, []);
    const filterbyname = (search) => {
        getsaleparsonreport(currentPage, limit, search);
        setstate({ ...state, currentPage: 1 });
    };
    const getlimit = (limit) => {
        setLimit(limit);
        getsaleparsonreport(1, limit);
        setstate({ ...state, currentPage: 1 });

    };
    const [state, setstate] = useState({
        totalPages: 20,
        currentPage: 1,
    });

    const { totalPages, currentPage } = state;
    const handlePaginations = (current) => {
        setstate({ ...state, currentPage: current });
        getsaleparsonreport(current, "");

    };
    const getsaleparsonreport = async (current, firstlimit, search) => {
        try {
            const postdata = {
                "search": search ? search : "",
                "start_date": datefilter ? datefilter[0] : "",
                "end_date": datefilter ? datefilter[1] : "",
                "limit": firstlimit ? firstlimit : limit,
                "skip": current ? (current - 1) * limit : 0,

            };
            let listdata = await _Api(postdata, `api/v1/POS/report/salesPerson`);
            if (listdata.code === 200) {
                setSalepersondata(listdata?.data);
                setstate({
                    ...state,
                    totalPages: Math.ceil(listdata?.count / postdata.limit),
                    currentPage: current ? current : 1
                });
                setUpercount(listdata?.uppercount);
                setLowercount(listdata?.lowercount);
            } else {
                setSalepersondata([]);
            }
        }
        catch (err) {
            console.log(err, "err");
        }
    }
    useEffect(() => {
        if (datefilter[0] && datefilter[1]) {
            getsaleparsonreport();
        }
        // eslint-disable-next-line
    }, [newcolumndata, datefilter]);

    const downloadexclsheet = async () => {
        let header_values = [];
        let bodyarray = [];
        possalepersonreport_head.map(async (r, k) => {
            header_values.push(r?.lable)
        })

        if (salepersondata.length) {
            salepersondata.forEach((result, key) => {

                bodyarray.push([key + 1, result?.sales_person, result?.Country, result?.location_name, result?.invoice, result?.qty, result?.customer
                    , result?.amount])
            })
        }
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(bodyarray, { origin: 'A2', skipHeader: true });
        XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: 'A1' });
        XLSX.utils.book_append_sheet(wb, ws, 'Records');
        const nombreArchivo = `unificado-.xlsx`;
        const rutaArchivo = `api_operaciones/files/unificados/${nombreArchivo}`;
        const colNames = ['A1', 'B1', 'C1'];
        for (const itm of colNames) {
            if (ws[itm]) {
                ws[itm].s = {
                    fill: { fgColor: { rgb: '00BFFF' } },
                    font: { color: { rgb: 'FFFFFF' } },
                };
            }
        }
        XLSX.writeFile(wb, rutaArchivo);

    }
    const selectOptions = [
        { label: 100, value: 100 },
        { label: 200, value: 200 },
        { label: 300, value: 300 }
    ]
    return (<>
        <div className="main-body">
            <div className="main-body-row">
                <div className="main-body-row-left-col p-0 w-100">
                    <div className="catalog-area bg-white page-menu-block Dailysalereport">
                        <div className="Dailysalereport-header">
                            <div className="Dailysalereport-header-left">
                                <h3 className='common-navigation-header-left-heading Dailysalereport-head'> <Link to="" className='gray-mid text-decoration-none Dailysalereport-head-report'>{t("REPORT")}</Link> <img className="Dailysalereport-head-arrow mx-3" src={base_assets + "images/pos/report/arrow-right.png"} alt="" /><span className="Dailysalereport-head-pagename">{t("Sale person report")}</span> </h3>
                            </div>
                            <div className="Dailysalereport-header-reportdetail">
                                <div className="Dailysalereport-header-reportdetail-box">
                                    <div className="Dailysalereport-header-reportdetail-box-inner">
                                        <img className="Dailysalereport-header-reportdetail-box-inner-img" src={base_assets + "images/pos/report/stock-img.png"} alt=""></img>
                                    </div>
                                    <div className="Dailysalereport-header-reportdetail-box-text">
                                        <span className="Dailysalereport-header-reportdetail-box-text-inner">{t("Total Qty")}</span>
                                        <span className="Dailysalereport-header-reportdetail-box-text-data lightblue">{uppercount?.qty}</span>
                                    </div>
                                </div>
                                <div className="Dailysalereport-header-reportdetail-box">
                                    <div className="Dailysalereport-header-reportdetail-box-inner">
                                        <img className="Dailysalereport-header-reportdetail-box-inner-img" src={base_assets + "images/pos/report/customer.png"} alt=""></img>
                                    </div>
                                    <div className="Dailysalereport-header-reportdetail-box-text">
                                        <span className="Dailysalereport-header-reportdetail-box-text-inner">{t("Total Cashier")}</span>
                                        <span className="Dailysalereport-header-reportdetail-box-text-data yellow-text">{uppercount?.cashier}</span>
                                    </div>
                                </div>
                                <div className="Dailysalereport-header-reportdetail-box">
                                    <div className="Dailysalereport-header-reportdetail-box-inner">
                                        <img className="Dailysalereport-header-reportdetail-box-inner-img" src={base_assets + "images/pos/report/loacation.png"} alt=""></img>
                                    </div>
                                    <div className="Dailysalereport-header-reportdetail-box-text">
                                        <span className="Dailysalereport-header-reportdetail-box-text-inner">{t("Total Location")}</span>
                                        <span className="Dailysalereport-header-reportdetail-box-text-data lightgray">{uppercount?.location}</span>
                                    </div>
                                </div>
                                <div className="Dailysalereport-header-reportdetail-box">
                                    <div className="Dailysalereport-header-reportdetail-box-inner">
                                        <img className="Dailysalereport-header-reportdetail-box-inner-img" src={base_assets + "images/pos/report/value-img.png"} alt=""></img>
                                    </div>
                                    <div className="Dailysalereport-header-reportdetail-box-text">
                                        <span className="Dailysalereport-header-reportdetail-box-text-inner">{t("Total Value")}</span>
                                        <span className="Dailysalereport-header-reportdetail-box-text-data maingreen">{uppercount?.total_amount}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="Dailysalereport-content-area">
                            <div className="Dailysalereport-content-area-header">
                                <div className="Dailysalereport-content-area-header-inner">
                                    <Reportmenupos
                                        Reportname={"Sale person report"} />
                                    <Select
                                        className="limit-select short mx-3"
                                        options={selectOptions}
                                        value={{ label: limit, value: limit }}
                                        onChange={(e) => { setLimit(e.value); getlimit(e.value) }}
                                    />
                                    <div className="date"> <Daterangepos setDatefilter={setDatefilter} /></div>
                                </div>
                                <div className="catalog-area-header-area-control-right">
                                    <div className="com-search-area">
                                        <input type="text" value={filtername} placeholder={t("Search  by Ref number, voucher type, ...")}
                                            onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                                            onChange={(e) => setFiltername(e.target.value)} />
                                        {filtername ? <img className="com-search-area-clear" src={base_assets + 'images/icons/False.png'} onClick={(e) => { setFiltername(""); filterbyname("") }} alt="" /> : ""}
                                        <img onClick={() => filterbyname(filtername)} className="com-search-area-img" src={base_assets + "images/pos/icons/magnifying-glass.png"} alt="" />

                                    </div>
                                    <div className=" dropdown Dailysalereport-content-area-header-leftdropdown">
                                        <button className='btn-style' type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><img src={base_assets + 'images/icons/ellipsis-circular.png'} alt="" /></button>
                                        <ul className="dropdown-menu Dailysalereport-content-area-header-leftdropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li onClick={() => getprintsaleparsonrreport()} className={parmissiondatashow?.pos_reports?.Print ? "" : "d-none"} >
                                                <Link className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" to="#">
                                                    <div className="dropdown-menu-img">
                                                        <img src={base_assets + "images/pos/report/print-icon.png"} alt="" />
                                                    </div>
                                                    {t("Print")}</Link>
                                            </li>
                                            <li onClick={() => downloadexclsheet()}>
                                                <Link className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" to="#">
                                                    <div className="dropdown-menu-img">
                                                        <img src={base_assets + "images/pos/report/export-icon.png"} alt="" />
                                                    </div>
                                                    {t("Export")}</Link>
                                            </li>
                                            <li data-bs-toggle="modal" data-bs-target="#socialModal" className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" onClick={() => getshareresalepersonreport()}>
                                                <div className="dropdown-menu-img">
                                                    <img src={base_assets + "images/pos/report/share-icon.png"} alt="" />
                                                </div>
                                                {t("Share")}
                                            </li>
                                            <li data-bs-toggle="modal" data-bs-target="#columnModal">
                                                <Link className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" to="#">
                                                    <div className="dropdown-menu-img">
                                                        <img src={base_assets + "images/icons/column-icon.png"} alt="" />
                                                    </div>
                                                    {t("Column")}</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="Dailysalereport-content-area-main"
                                ref={reportTableContainerRef}
                            >
                                <div className="main-body-main-table-wrap Dailysalereport-table position-relative" id="table-scroll">
                                    <table id='saleperson_report' className="common-table first-row-gray w-100 Dailysalereport-table-main daily-sale-report-table sale-person-report-table">
                                        <DailySaleReportTableHead
                                            tablehead={activeTableColumns}
                                            sortConfig={sortConfig}
                                            onSort={handleSalePersonSort}
                                            columnFilters={columnFilters}
                                        />
                                        <tbody>
                                            <>
                                                {salepersondata.length ? sortedSalepersondata.map((result, key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td>{key + 1}</td>
                                                            <td>{result?.sales_person ? result?.sales_person : ""}</td>
                                                            <td>{result?.Country ? result?.Country : ""}</td>
                                                            <td>{result?.location_name ? result?.location_name : ""}</td>
                                                            <td>{result?.invoice ? result?.invoice : ""}</td>
                                                            <td>{result?.qty ? result?.qty : ""}</td>
                                                            <td>{result?.customer ? result?.customer : ""}</td>
                                                            <td>{result?.amount ? toFormatPrice(result?.amount, { addSymbol: true }) : ""}</td>

                                                        </tr>
                                                    )
                                                }) : ""}
                                            </>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{lowercount?.invoice}</td>
                                                <td>{lowercount?.qty}</td>
                                                <td>{lowercount?.customer}</td>
                                                <td>{toFormatPrice(lowercount?.total_amount, { addSymbol: true })}  </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            {salepersondata.length > 0 ? (
                                <Pagination
                                    total={totalPages}
                                    current={currentPage}
                                    pagination={(crPage) => handlePaginations(crPage)}
                                />
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <SocialModal shareUrl={socialurl} shareloader={shareloader} />
            <TableModal tablehead={possalepersonreport_head} tblName={"report_salepersonreport_tbl"} setnewcolumndata={setnewcolumndata} />
        </div>

    </>)
}
export default Salepersonreport;
















